<template>
  <v-container class="user-form">
    <span class="fibl-headline">{{ $t('userRegister.headline') }}</span>
      <v-card flat>
        <v-card-text class="user-register">
          <v-form class="user__register-form" ref="form" v-model="valid">
            <v-text-field
              class="above-align"
              name="name"
              :label="$t('userRegister.name')"
              type="name"
              clearable
              v-model="name"
            >
            </v-text-field>
            <v-spacer></v-spacer>
            <v-text-field
              class="above-align"
              name="organisation"
              :label="$t('userRegister.organization')"
              type="email"
              clearable
              v-model="organization"
            >
            </v-text-field>
            <v-text-field
              class="above-align"
              name="email"
              :label="$t('userRegister.mail')"
              type="email"
              clearable
              v-model="email"
              :rules="emailRules"
              required
            >
            </v-text-field>
            <v-text-field
              :hint="$t('userRegister.hint.passwordRules')"
              persistent-hint
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              clearable
              name="password"
              :label="$t('userRegister.password')"
              id="password"
              :type="show ? 'text' : 'password'"
              @click:append="show = !show"
              required
              v-model="password"
              :rules="passwordRules"
            >
            </v-text-field>

            <v-checkbox
              v-model="dataprotection_accepted"
              :rules="dataProtectionRules"
            >
              <template slot=label>
                <span class="user__register-form-label">
                  {{$t('userRegister.dataPrivacy.text1')}} <router-link to="/info/data-protection">{{$t('userRegister.dataPrivacy.privacyPolicy')}}</router-link> {{$t('userRegister.dataPrivacy.text2')}}
                </span>
              </template>
            </v-checkbox>
          </v-form>
          
        </v-card-text>

          <v-card-actions>
            <v-btn
              class="button__secondary user__register-form-button "
              depressed
              @click="cancel"
            >
            {{ $t('userRegister.cancel') }}</v-btn
            >
            <v-btn
              class="button__primary user__register-form-btn "
              depressed
              :disabled="!valid"
              @click="submit"
            >
            {{ $t('userRegister.register') }}
            </v-btn>
          </v-card-actions>
        </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "UserRegister",

  computed: {
    ...mapState(["user", "message", "error"]),
  },

  data() {
    return {
      emailEntered: false,
      passwordEntered: false,
      valid: false,
      name: "",
      organization: "",
      email: "",
      password: "",
      dataprotection_accepted: false,
      show: false,
      showError: false,
      showSuccess: true,
      emailRules: [
        (v) => !!v || this.$i18n.t('userRegister.hint.mailRequired'),
        (v) => /.+@.+/.test(v) || this.$i18n.t('userRegister.hint.mailInvalid')
      ],
      passwordRules: [
        (v) => !!v || this.$i18n.t('userRegister.hint.passwordRequired'),
        (v) => v.length >= 8 || this.$i18n.t('userRegister.hint.charNumber'),
        (v) =>
          v.match(/[0-9]+/) ||
          this.$i18n.t('userRegister.hint.passwordRules'),
        (v) =>
          v.match(/[a-z]+/) ||
          this.$i18n.t('userRegister.hint.passwordRules'),
        (v) =>
          v.match(/[A-Z]+/) ||
          this.$i18n.t('userRegister.hint.passwordRules')
      ],
      dataProtectionRules: [
        (v) => !!v || this.$i18n.t('userRegister.hint.privacyPolicy')
      ]
    };
  },

  methods: {

    submit() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("signup", {
          name: this.name,
          organization: this.organization,
          email: this.email,
          password: this.password,
        });
      }
    },

    cancel() {
      this.$router.push("/");
    },
  },

};
</script>
